import React from 'react'

const ButtonArrowIcon = () => {
    return (
        <svg
            style={{ width: '30%' }}
            //  width="24" height="24"
            viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_464_428)">
                <path d="M1.68359 22.3174L22.3184 1.68262M22.3184 1.68262V21.492M22.3184 1.68262H2.50898" stroke="white" stroke-width="2.38093" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_464_428">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default ButtonArrowIcon